if (!customElements.get('kh-pendant-klarna')) {
  customElements.define('kh-pendant-klarna', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.sync = this.sync.bind(this);
      this.productInfo.addEventListener('change', this.sync);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.productInfo, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-purchase-amount'] });
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.productInfo?.removeEventListener('change', this.sync);
    }
    sync() {
      const data = this.productInfo.querySelector('variant-selects [data-selected-variant]');
      let price = Number(this.dataset.initialPrice);
      if (data) {
        try { price = JSON.parse(data.textContent)?.price ?? price; } catch {}
      }
      if (!Number.isFinite(price) || price <= 0) return;
      this.querySelectorAll('klarna-placement').forEach(placement => {
        if (placement.getAttribute('data-purchase-amount') !== String(price)) {
          placement.setAttribute('data-purchase-amount', String(price));
        }
      });
    }
  });
}
